import {
  ForgotPasswordActions,
  ForgotPasswordActionTypes,
} from "../actions/forgotPasswordAction";

export interface ForgotPasswordState {
  id: string;
  step: "otp_sent" | "otp_verified" | "password_reset" | "error";
  message: string;
}

const initialState: ForgotPasswordState[] = [];

export const forgotPasswordReducer = (
  state: ForgotPasswordState[] = initialState,
  action: ForgotPasswordActions,
): ForgotPasswordState[] => {
  switch (action.type) {
    case ForgotPasswordActionTypes.REQUEST_OTP_SUCCESS:
      return [
        ...state,
        {
          id: "otp", // or "temp" - optionally map it to employeeId if needed
          step: "otp_sent",
          message: action.message,
        },
      ];

    case ForgotPasswordActionTypes.VERIFY_OTP_SUCCESS:
      return [
        ...state,
        {
          id: "otp",
          step: "otp_verified",
          message: action.message,
        },
      ];

    case ForgotPasswordActionTypes.RESET_PASSWORD_SUCCESS:
      return [
        ...state,
        {
          id: "otp",
          step: "password_reset",
          message: action.message,
        },
      ];

    case ForgotPasswordActionTypes.FORGOT_PASSWORD_ERROR:
      return [
        ...state,
        {
          id: "otp",
          step: "error",
          message: action.error,
        },
      ];

    default:
      return state;
  }
};
